import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  FunctionField,
} from 'react-admin';
import { DATE_TIME_OPTIONS } from '../../app/app.component';
import { DEFAULT_LIST_PERPAGE } from '../../utils/constants';
import DefaultPlaceholderField from '../../material/defPlaceholderField.component';
import { leadFilters } from './leadFilters.component';
//Sidebar filters removed
import { leadsFields } from '../leads.model';
import LeadLinkField from './leadLink.component';
import StatusField from './statusField.component';
import ListActions from './listActions.component';
import AddressField from './addressField.component';
import ActionsMenu from './ActionsMenu.component';
import LeadsAnalyticsPanel from './LeadsAnalyticsPanel.component';


export const LeadList = () => (
  <List
    title="Leads"
    perPage={DEFAULT_LIST_PERPAGE}
    sort={{ field: leadsFields.createdAt, order: 'DESC' }}
    filters={leadFilters}
    actions={<ListActions />}
    filterDefaultValues={{ status: 'active', includeArchived: false }}
    storeKey="leads-list"
    sx={{
      '& .RaList-main': { margin: '0.5em' },
      '& .column-id': { width: '8%' },
      '& .column-name': { width: '15%' },
      '& .column-email': { width: '18%' },
      '& .column-phone_number': { width: '12%' },
      '& .column-address': { width: '20%' },
      '& .column-source_org': { width: '15%' },
      '& .column-status': { width: '8%' },
      '& .column-created_at': { width: '10%' },
      '& .column-actions': { width: '8%' },
      // Improved filter bar styling
      '& .RaFilterForm-filterFormInput': {
        minWidth: 180,
        marginRight: '1rem'
      },
      '& .filter-field': {
        margin: 0,
      },
      '& .filter-button': {
        marginRight: '1rem',
      },
      '& .RaFilterFormInput-input': {
        marginBottom: 0
      },
    }}
  >
    <LeadsAnalyticsPanel />
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}
      rowStyle={(record) =>
        record?.isArchived
          ? {
              // Archived rows: subtle tint + stripe + light pattern (no opacity)
              backgroundColor: '#fafafa',
              backgroundImage:
                'linear-gradient(to right, #9e9e9e 4px, transparent 4px), repeating-linear-gradient(-45deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 4px, transparent 4px, transparent 10px)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%, 100% 100%',
              // Slightly mute text to match archived state, but keep readable
              color: '#616161',
              // Thin inner border to make row stand out
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
            }
          : {}
      }
    >
      <LeadLinkField label="ID" />
      <DefaultPlaceholderField
        source={leadsFields.batchId}
        wrapField={<TextField source={leadsFields.batchId} />}
        label="Batch ID"
      />
      <DefaultPlaceholderField
        source={leadsFields.name}
        wrapField={<TextField source={leadsFields.name} />}
        label="Name"
      />
      <DefaultPlaceholderField
        source={leadsFields.email}
        wrapField={<EmailField source={leadsFields.email} />}
      />
      <DefaultPlaceholderField
        source={leadsFields.phoneNumber}
        wrapField={<TextField source={leadsFields.phoneNumber} />}
        label="Phone"
      />
      <AddressField label="Address" />
      <DefaultPlaceholderField
        source={leadsFields.language}
        wrapField={<TextField source={leadsFields.language} />}
        label="Language"
      />
      <DefaultPlaceholderField
        source={leadsFields.sourceOrg}
        wrapField={<TextField source={leadsFields.sourceOrg} />}
        label="Source Organization"
      />
      <DefaultPlaceholderField
        source={leadsFields.wicClinicCode}
        wrapField={<TextField source={leadsFields.wicClinicCode} />}
        label="WIC Clinic Code"
      />
      <DefaultPlaceholderField
        source={leadsFields.status}
        wrapField={<StatusField />}
        label="Status"
      />
      <DefaultPlaceholderField
        source={leadsFields.createdAt}
        wrapField={<DateField options={DATE_TIME_OPTIONS} source={leadsFields.createdAt} />}
        label="Created"
      />
      <DefaultPlaceholderField
        source={leadsFields.birthDate}
        wrapField={<DateField options={DATE_TIME_OPTIONS} source={leadsFields.birthDate} />}
        label="Birth Date"
      />
      <FunctionField
        label="Actions"
        render={(record) => <ActionsMenu record={record} />}
      />
    </Datagrid>
  </List>
);

export default LeadList;
